module.exports = __webpack_public_path__ + "images/cordovaLogo-ccddab6c0297bd66749c687f654c6276.png";